import Backbone from 'backbone'
import _ from 'lodash'

const RTL = Backbone.View.extend({

  initialize: function (options) {
    this.canvas = options.canvas
    this.wobs = this.canvas.collection

    this.setupTransform()
    this.overrideCanvasMethods()
    this.listenToEvents()
  },

  /*
   * Override the wobs transform so they are moved
   * in the opposite direction.
   */
  setupTransform: function () {
    // Override the `transform` on the wobs so it moves in the opposite direction
    this.wobs.transform = (x, y) => {
      if (this.wobs.length === 0) {
        return
      }
      const bb = this.canvas.boundingBox()
      const farRightWob = _.maxBy(this.canvas.collection.models, w => w.get('left') + w.get('width'))
      const farRight = farRightWob.get('left') + farRightWob.get('width')
      const transformX = x + (this._width - farRight) // How much we need to move the wobs to the right
      const transformY = y - bb.minY

      this.wobs.forEach(wob => {
        wob.set({
          left: wob.get('left') + transformX,
          top: wob.get('top') + transformY
        }, {animate: true})
        wob.trigger('move', wob, {animate: true})
      })
    }
  },

  /*
   * Overrides the canvas resize method to adjust the canvas width using
   * the internal `_width` property
   */
  _canvasResize: function () {
    const bb = this.canvas.boundingBox()

    this.canvas.trigger('resize', bb)

    this.canvas.$el
      .height(bb.maxY)
      .width(this._width)
  },

  /*
   * Override the canvas correctBounds method so it snaps the selection area
   * to the left if the right-most edge is greater than the width of the canvas
   */
  _correctBounds: function () {
    const area = this.canvas.selection.area()

    // Determine if the area is outside the width of the canvas
    const move = {
      left: area.right > this._width ? (this._width - area.right) : 0,
      top: area.top < 0 ? area.top * -1 : 0
    }

    if (move.left || move.top) {
      this.canvas.selection.moveBy(move)
    }
  },

  /*
   * Override the canvas methods to adjust the canvas width transform
   */
  overrideCanvasMethods: function () {
    this.canvas._resize = this._canvasResize.bind(this)
    this.canvas.correctBounds = this._correctBounds.bind(this)
  },

  listenToEvents: function () {
    this.canvas.on('ready', () => {
      // When the canvas is initialized, we need to store the maxX value of the wob's bounding box
      // We *know* by definition that there is a wob that has its right-most edge at the right-most edge of the canvas
      this._width = this.canvas.boundingBox().maxX
    })

    this.canvas.on('wob:added', view => {
      // Adjust the canvas width transform
      this.adjustTransform()
    })

    // When wobs move, adjust the transform
    this.canvas.collection.on('move', wob => {
      if (wob.get('left') < 0) {
        // Adjust the canvas edges transform so the edges include the wob
        // This handles live resizing of the canvas, once the `resize` events on the canvas, we'll
        // properly adjust `left` coordinates so we're not in negative space
        this.canvas.$('.canvas-edges').css({'transform': `translateX(${wob.get('left')}px)`})

        // Increase the size of the editable-canvas
        this.canvas.$el.width(this._width - wob.get('left'))
      }
    })

    this.canvas.on('resize', () => {
      // Find the left most wob
      const leftMost = _.minBy(this.canvas.collection.models, w => w.get('left'))

      if (!leftMost) {
        return
      }

      // Check if we're resizing a selection
      if (this.canvas.$el.hasClass('is-resizing')) {
        // If we are, we need to adjust the canvas edges transform so the edges include the wob
        this.canvas.$('.canvas-edges').css({'transform': `translateX(${leftMost.get('left')}px)`})
        return
      }

      // We want to make sure that the left most wob is at `0`.
      // If it's not, we want to move all the wobs to the right by the amount the left most wob is from `0`
      if (leftMost.get('left') < 0) {
        const diff = leftMost.get('left') * -1

        // // Move all wobs by `diff`
        this.canvas.collection.each(w => {
          w.set('left', w.get('left') + diff)
          w.trigger('move', w) // Trigger the move event so connectors are updated
        })

        // Remove the transform from the canvas edges
        this.canvas.$('.canvas-edges').css({'transform': 'none'})

        // Honestly I have no f'ing clue what is happening, but after 5 hours, this block fixed the issue
        // where moving wobs to the left doesn't force them back to the top right corner
        const width = parseInt(this.canvas.el.style.width) // Get the current width of the canvas as its set as the style. jquery width is returning calculated nonsense
        this.canvas.$el.css('transform', `translateX(calc(100% - ${width}px))`)
        this._width = width - this.canvas.padding * 2
      }
    })
  },

  adjustTransform: function () {
    // Adjust the canvas width transform
    const width = this.canvas.boundingBox().maxX + this.canvas.padding * 2
    this.canvas.$el.css({
      transform: `translateX(calc(100% - ${width}px))`
    })
    this.canvas.$el.width(width)
    this._width = width - this.canvas.padding * 2
  },

})

export default function (canvas) {
  // Only return the RTL if the browser is in RTL mode
  if (document.dir === 'rtl') {
    return new RTL({ canvas })
  }
}
